package navigation.home.clients

import navigation.home.clients.addeditclient.AddEditClientScreenModel
import navigation.home.clients.allclients.AllClientsScreenModel
import org.koin.dsl.module

val clientUiModule
    get() =
        module {

            factory {
                AllClientsScreenModel(
                    clientRepository = get(),
                    loadingManager = get()
                )
            }

            factory {
                AddEditClientScreenModel(
                    clientRepository = get(),
                    proposalRepository = get(),
                    itineraryRepository = get(),
                    toastManager = get(),
                    loadingManager = get()
                )
            }
        }
